import './Contact.css';
import { useEffect, useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // يمكن إضافة منطق إرسال النموذج هنا
    alert('شكراً لتواصلك معنا! سنرد عليك في أقرب وقت ممكن.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">
      <div className="header-spacer"></div>

      {/* Animated Background */}
      <div className="animated-background">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
        <div className="floating-shape shape-5"></div>
      </div>

      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <div className="sparkle-wrapper">
              <span className="sparkle">✨</span>
              <h1 className="main-title">يسعدنا تواصلكم معنا</h1>
              <span className="sparkle">✨</span>
            </div>
            <div className="subtitle-wrapper">
              <div className="line"></div>
              <p className="subtitle">والاستماع إليكم</p>
              <div className="line"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Cards Section */}
      <section className="contact-cards-section">
        <div className="container">
          <div className="cards-wrapper">
            
            {/* Phone Card */}
            <div className="contact-card phone-card">
              <div className="card-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
              </div>
              <div className="card-content">
                <div className="icon-wrapper">
                  <div className="icon-circle">
                    <span className="icon">📞</span>
                  </div>
                  <div className="icon-glow"></div>
                </div>
                <h3 className="card-title">أرقام التواصل</h3>
                <div className="divider"></div>
                <div className="phone-numbers">
                  <a href="https://wa.me/97192433000" target="_blank" rel="noopener noreferrer" className="phone-number">
                    <span className="number-icon">💬</span>
                    <span dir="ltr">0097192433000</span>
                  </a>
                  <a href="https://wa.me/971559512173" target="_blank" rel="noopener noreferrer" className="phone-number">
                    <span className="number-icon">💬</span>
                    <span dir="ltr">00971559512173</span>
                  </a>
                  <a href="https://wa.me/971567953704" target="_blank" rel="noopener noreferrer" className="phone-number">
                    <span className="number-icon">💬</span>
                    <span dir="ltr">00971567953704</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Address Card */}
            <div className="contact-card address-card">
              <div className="card-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
              </div>
              <div className="card-content">
                <div className="icon-wrapper">
                  <div className="icon-circle">
                    <span className="icon">📍</span>
                  </div>
                  <div className="icon-glow"></div>
                </div>
                <h3 className="card-title">موقعنا</h3>
                <div className="divider"></div>
                <div className="address-info">
                  <p className="address-line">🇦🇪 دولة الإمارات العربية المتحدة</p>
                  <p className="address-line">🏛️ الفجيرة</p>
                  <p className="address-line">🌊 دبا الفجيرة</p>
                  <p className="address-line highlight">⭐ الراشدية</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}

export default Contact;
